import LockIcon from "@mui/icons-material/Lock";
import SpeedIcon from "@mui/icons-material/Speed";
import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import ContainedButton from "../../../../components/buttons/ContainedButton";

const ApiDocsOverview = () => {
  const colors = useColors();

  const apiSections = [
    {
      id: "authentication",
      title: "Authentication",
      icon: <LockIcon />,
      description:
        "All API endpoints require authentication using an API key. Include your API key in the Authorization header: Bearer <your_api_key>",
      hasButton: true,
    },
    {
      id: "rate-limiting",
      title: "Rate Limiting",
      icon: <SpeedIcon />,
      description:
        "API enforces 100 requests per minute per API key. Rate limit information is included in response headers.",
    },
  ];

  return (
    <Box sx={{ mb: 4, mt: 4 }}>
      <Grid container spacing={3}>
        {apiSections.map((section) => (
          <Grid item xs={12} md={6} key={section.id}>
            <Card
              sx={{
                height: "100%",
                border: `1px solid ${colors.border || "#e0e0e0"}`,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Stack spacing={2}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography variant="h4">{section.icon}</Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: colors.text_primary,
                      }}
                    >
                      {section.title}
                    </Typography>
                  </Stack>

                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.text_secondary,
                      lineHeight: 1.6,
                    }}
                  >
                    {section.description}
                  </Typography>

                  {section.hasButton && (
                    <Box sx={{ pt: 1 }}>
                      <ContainedButton
                        color="primary"
                        size="medium"
                        onClick={() =>
                          window.open(
                            "/settings?category=organization_settings&page=api_keys",
                            "_blank",
                            "noopener,noreferrer"
                          )
                        }
                      >
                        Generate API Key
                      </ContainedButton>
                    </Box>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ApiDocsOverview;
